import { ListItem, Tooltip } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { fontSize, palette } from '../../..';
import WarningIcon from '@mui/icons-material/WarningAmber';

interface MeasureCardProps {
  name: string;
  handleDelete: () => void;
  showWarning: boolean;
}

const MeasureCard = ({ name, handleDelete, showWarning }: MeasureCardProps) => {
  const CancelIcon = () => {
    return (
      <CloseRoundedIcon
        onClick={handleDelete}
        sx={{
          fontSize: fontSize.medium,
          cursor: 'pointer',
          color: palette.primary.contrastText,
          '&:hover': {
            color: 'red',
            transform: 'scale(1.1)',
          },
        }}
      />
    );
  };

  return (
    <ListItem sx={{ padding: '0px' }}>
      <div
        className="axisFilterField"
        style={{
          border: '1px solid grey',
          borderRadius: '5px',
          paddingLeft: '0.3rem',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          height: '1.5rem',
          width: '100%',
          gap: '0.2rem',
          boxSizing: 'border-box',
          marginTop: '6px',
          marginBottom: '6px',
        }}
      >
        <CancelIcon />
        <span
          style={{
            lineHeight: '15px',
            fontSize: fontSize.medium,
            color: palette.primary.contrastText,
          }}
        >
          {name !== undefined || '' ? name : ''}
        </span>
        {showWarning && (
          <Tooltip
            title="Some measures are not mapped. Use measure mapping to map all measures."
            arrow
            placement="top"
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                },
              },
            }}
          >
            <WarningIcon
              style={{
                marginLeft: 'auto',
                cursor: 'pointer',
                marginRight: '8px',
                color: 'orange',
                fontSize: '1em',
                transition: 'color 0.3s, font-size 0.3s',
              }}
            ></WarningIcon>
          </Tooltip>
        )}
      </div>
    </ListItem>
  );
};

export default MeasureCard;
